import React from "react";

export default function FilterSelect({
  value,
  onChange,
  options = [],
  placeholder,
  size = "md", // "sm" | "md"
  style = {},
  className = "",
  disabled = false,
  ariaLabel,
}) {
  const heightStyle = size === "sm" ? { padding: "4px 8px", fontSize: 11.5 } : {};

  return (
    <select
      aria-label={ariaLabel}
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      disabled={disabled}
      className={`form-select ${className}`}
      style={{
        width: "auto",
        minWidth: 120,
        cursor: "pointer",
        ...heightStyle,
        ...style,
      }}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((opt) => {
        const val = typeof opt === "object" && opt !== null ? opt.value : opt;
        const lbl = typeof opt === "object" && opt !== null ? opt.label : opt;
        return (
          <option key={val} value={val}>
            {lbl}
          </option>
        );
      })}
    </select>
  );
}
